import { EntityDialog } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import { Authorization, Config, ErrorHandling } from "@serenity-is/corelib/q";
import { IdleTimeout } from "@serenity-is/pro.extensions";
import { siteLanguageList } from "./Helpers/LanguageList";

// ─────────────────────────────
// Bootstrap 5 + jquery-minicolors
// ─────────────────────────────
/*import "bootstrap/dist/js/bootstrap.bundle.js";
import "bootstrap/dist/css/bootstrap.css";

import "@claviska/jquery-minicolors/jquery.minicolors.js";
import "@claviska/jquery-minicolors/jquery.minicolors.css";*/

Config.rootNamespaces.push('CXmarketing');
EntityDialog.defaultLanguageList = siteLanguageList;
gridDefaults.useCssVars = true;

if ($.fn['colorbox']) {
    $.fn['colorbox'].settings.maxWidth = "95%";
    $.fn['colorbox'].settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;

$(() => {
    // let demo page use its own settings for idle timeout
    if (window.location.pathname.indexOf('Samples/IdleTimeout') > 0)
        return;

    var meta = $('meta[name=username]');
    if ((meta.length && meta.attr('content')) ||
        (!meta.length && Authorization.isLoggedIn)) {

        new IdleTimeout({
            activityTimeout: 180 * 60,
            warningDuration: 2 * 60
        });
    }
});
